import { createSlice } from "@reduxjs/toolkit";

const paidJobsFeature = createSlice({
    name: 'paidjobs',
    initialState: {
        jobs: []
    },
    reducers: {
       setPaidJobs: (state, action) => {
            state.jobs = [...state.jobs, action.payload]
       }
    }
});

export const { setPaidJobs } = paidJobsFeature.actions;
export default paidJobsFeature.reducer;